export const patientService = (request) => {
  
  const PATIENT_API_ENDPOINT = '/service/liquidlove/patients';
  //const PATIENT_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/patients';
  
  const parameters = {
    method: 'POST',
    credentials: 'include',
    headers: {      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.patient.data)
  };

  return fetch(PATIENT_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const updatePatientService = (request) => {
  
  const UPDATE_PATIENT_API_ENDPOINT = '/service/liquidlove/closeRequest';
  //const UPDATE_PATIENT_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/closeRequest';
  
  const parameters = {
    method: 'POST',    
    
    headers: {
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.patient)
  };

  return fetch(UPDATE_PATIENT_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchAllPatientsService = (request) => {  
  const ALL_PATIENT_FETCH_API_ENDPOINT = '/service/liquidlove/patientsByStatusAndDistrict';
  //const ALL_PATIENT_FETCH_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/patientsByStatusAndDistrict';
    
  const parameters = {
    method: 'POST',
    headers: {      
      'Authorization': 'Bearer ' + request.payload.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.payload)    
  };

  return fetch(ALL_PATIENT_FETCH_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchPatientService = (request) => {
  const PATIENT_FETCH_API_ENDPOINT = '/service/liquidlove/getPatientById/' + request.patient.reqId;
  //const PATIENT_FETCH_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/getPatientById/' + request.patient.reqId;

  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(PATIENT_FETCH_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchPatientsByPatientNameService = (request) => {
  const FETCH_BY_PATIENT_NAME_API_ENDPOINT = '/service/liquidlove/getPatientByName/' + request.patient.patientName + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;
  //const FETCH_BY_PATIENT_NAME_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/getPatientByName/' + request.patient.patientName + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;

  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(FETCH_BY_PATIENT_NAME_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchPatientsByAttenderNameService = (request) => {
  const FETCH_BY_ATTENDER_NAME_API_ENDPOINT = '/service/liquidlove/getPatientByAttenderName/' + request.patient.attenderName + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;
  //const FETCH_BY_ATTENDER_NAME_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/getPatientByAttenderName/' + request.patient.attenderName + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;

  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(FETCH_BY_ATTENDER_NAME_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchPatientByPhoneService = (request) => {
  const FETCH_BY_PATIENT_PHONE_API_ENDPOINT = '/service/liquidlove/getPatientByPhone/' + request.patient.phone + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;
  //const FETCH_BY_PATIENT_PHONE_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/getPatientByPhone/' + request.patient.phone + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&sortOrder=' + request.patient.sortOrder;

  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(FETCH_BY_PATIENT_PHONE_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const verifyPatientService = (request) => {
  
  const PATIENT_VERIFY_API_ENDPOINT = '/service/liquidlove/updateRequest';
  //const PATIENT_VERIFY_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/updateRequest';

  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.patient.data)    
  };

  return fetch(PATIENT_VERIFY_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const matchingDonorsService = (request) => {
  
  const MATCH_DONORS_API_ENDPOINT = '/service/liquidlove/matchDonors/' + request.patient.reqId + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&countryFilter=' + encodeURIComponent(request.patient.country) + '&stateLocationFilter=' + encodeURIComponent(request.patient.stateLocation) + '&districtFilter=' + encodeURIComponent(request.patient.districtFilter) + '&localityFilter=' + encodeURIComponent(request.patient.localityFilter) + '&name=' + request.patient.nameFilter;
  //const MATCH_DONORS_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/matchDonors/' + request.patient.reqId + '?size=' + request.patient.size + '&page=' + request.patient.pageNum + '&countryFilter=' + request.patient.country + '&stateLocationFilter=' + request.patient.stateLocation + '&districtFilter=' + request.patient.districtFilter + '&localityFilter=' + request.patient.localityFilter + '&name=' + request.patient.nameFilter;

  const parameters = {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + request.patient.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(MATCH_DONORS_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const matchDonorbyPhoneService = (request) => {
  
  const MATCH_DONOR_PHONE_API_ENDPOINT = '/service/liquidlove/matchDonor/patient/' + request.payload.reqId + '?donorPhone=' + request.payload.donorPhone +'&size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + encodeURIComponent(request.payload.country) + '&stateLocationFilter=' + encodeURIComponent(request.payload.stateLocation) + '&districtFilter=' + encodeURIComponent(request.payload.districtFilter) + '&localityFilter=' + encodeURIComponent(request.payload.localityFilter);
  //const MATCH_DONOR_PHONE_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/matchDonor/patient/' + request.payload.reqId + '?donorPhone=' + request.payload.donorPhone +'&size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + encodeURIComponent(request.payload.country) + '&stateLocationFilter=' + encodeURIComponent(request.payload.stateLocation) + '&districtFilter=' + encodeURIComponent(request.payload.districtFilter) + '&localityFilter=' + encodeURIComponent(request.payload.localityFilter);

  const parameters = {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + request.payload.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(MATCH_DONOR_PHONE_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const saveMatchingDonorService = (request) => {
  
  const SAVE_MATCHING_DONOR_API_ENDPOINT = '/service/liquidlove/saveMatchingDonor';
  //const SAVE_MATCHING_DONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/saveMatchingDonor';

  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.saveMatchingDonorPayload.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.saveMatchingDonorPayload.matchingDonor)    
  };

  return fetch(SAVE_MATCHING_DONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};